export function PageDefault({ ...props }) {
  return (
    <svg viewBox="0 0 20 26" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.478 1.168a1.05 1.05 0 0 0-.724.562l-.071.153v20.2l.094.298c.172.551.394.927.771 1.306.384.387.843.648 1.405.801.222.06.486.062 7.047.062s6.825-.002 7.047-.062c1.081-.294 1.837-1.027 2.178-2.112l.092-.293.009-7.072.008-7.072-.071-.195c-.068-.186-.204-.328-3.175-3.303-2.591-2.596-3.135-3.125-3.288-3.2l-.183-.091-5.5-.005c-3.025-.003-5.563.008-5.639.023m8.73 5.19.009 3.225.103.184c.111.196.338.393.541.469.1.037.707.048 3.298.056l3.175.01-.009 5.757-.008 5.758-.093.189a1.024 1.024 0 0 1-.467.469l-.14.075H3.383l-.169-.09a1.048 1.048 0 0 1-.46-.492l-.071-.151-.008-9.342-.009-9.342H10.199l.009 3.225m-3.775 7.709v.5h7.134v-1H6.433v.5m0 4.733v.5h7.134v-1H6.433v.5"
        fillRule="evenodd"
        fill="currentColor"
      />
    </svg>
  );
}
